import { Collection } from '@/kernel/collection';

import StringCell from '@/components/cells/string-cell.vue';
import DateCell from '@/components/cells/date-cell.vue';
import BooleanCell from '@/components/cells/boolean-cell.vue';
import AssessmentTemplateActionsCell from '@/components/cells/assessment-template-actions-cell.vue';

import { DateRangeFilterAdapter, SelectFilterAdapter, SingleRelationInputAdapter, ObjectivePickerInputAdapter, OrganisationFilterContextAdapter, OrganisationFormContextAdapter } from '@/kernel/adapters';

import DateRangeInput from '@/components/inputs/date-range-input.vue';
import TextInput from '@/components/inputs/text-input.vue';
import CheckboxInput from '@/components/inputs/checkbox-input.vue';
import SelectInput from '@/components/inputs/select-input.vue';
import SingleRelationInput from '@/components/inputs/single-relation-input.vue';
import ObjectivePickerInput from '@/components/inputs/objective-picker-input.vue';

export class AssessmentTemplate extends Collection {
  config = {
    autoRoute: true,
    requiresOrganisation: true,
    key: 'assessment-template',
    pluralLabel: 'Assessment Templates',
    singleLabel: 'Assessment Template',
    indexUrl: '/assessment-template',
    createUrl: '/assessment-template/create',
    searchKeys: ['name'],
    editUrlPrefix: '/assessment-template',
    idKey: 'id',
    nameKey: 'name',
    payloadEndpoint: '/assessment-template',
    defaultSort: {
      key: 'name',
      order: 1
    },
    indexColumns: [
      {name: 'Actions', key: 'edit', sortable: false, cell: AssessmentTemplateActionsCell, props: {collection: 'assessment-template'}},
      {name: 'Name', key: 'name', sortable: true, cell: StringCell},
      {name: 'Updated', key: 'updatedAt', sortable: true, cell: DateCell},
      {name: 'Created', key: 'createdAt', sortable: true, cell: DateCell}
    ],
    indexFilters: [
      {key: 'updatedAt', label: 'Updated at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Updated at'}},
      {key: 'createdAt', label: 'Created at', input: DateRangeInput, adapter: DateRangeFilterAdapter, props: {label: 'Created at'}}
    ],
    indexContexts: [
      {key: 'organisation', adapter: OrganisationFilterContextAdapter}
    ],
    indexSelects: {
      name: true,
      updatedAt: true,
      createdAt: true
    },
    createFormContexts: [
      {key: 'organisation', adapter: OrganisationFormContextAdapter}
    ],
    createFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'objectives', label: 'Objectives',  input: ObjectivePickerInput, adapter: ObjectivePickerInputAdapter('objective'), props: {label: 'Objectives', collection: 'objective'}}
    ],
    editFormFields: [
      {key: 'name', label: 'Name', input: TextInput, props: {label: 'Name'}},
      {key: 'objectives', label: 'Objectives',  input: ObjectivePickerInput, adapter: ObjectivePickerInputAdapter('objective'), props: {label: 'Objectives', collection: 'objective'}}
    ]
  }

  getRedirectAfterCreate(item) {
    return '/';
  }

  getPDFExportUrl(item) {
    return `/export/assessment-template/${item.id}`;
  }

}
